import { PropsWithChildren, useCallback, useState } from "react";

import { Link } from "../../link/src/link";

import { Modal } from "./modal";

export interface ModalLinkProps extends PropsWithChildren {
    modalTitle?: string;
    modalCloseLabel?: string;
    ctaText: string;
}

export const ModalLink = ({
    modalTitle,
    modalCloseLabel,
    children,
    ctaText
}: ModalLinkProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const openModal = (e: { preventDefault: () => void }) => {
        e.preventDefault();
        setIsOpen(true);
    };
    const closeModal = useCallback(() => setIsOpen(false), []);

    return (
        <>
            {/* TODO: It's not ideal to use an anchor here due to the modal component 
            being internal to the page, but we are compromising for now to achieve 
            the desired styling */}
            <Link onClick={openModal} text={ctaText} href="#" type="modal" />
            <Modal
                closeModal={closeModal}
                closeLabel={modalCloseLabel}
                title={modalTitle}
                isOpen={isOpen}
            >
                {children}
            </Modal>
        </>
    );
};
